<div class="go-input-container">
  <label *ngIf="label"
         class="go-form__label"
         [attr.for]="_id"
         [ngClass]="{'go-form__label--dark': theme === 'dark'}">
    {{ label }}
    <go-required-text [control]="control"></go-required-text>
  </label>
  <input
    class="go-form__input"
    [id]="_id"
    [ngClass]="inputClasses"
    [type]="inputType"
    [placeholder]="placeholder"
    [formControl]="control"
    [maxlength]="maxlength"
    [minlength]="minlength"
  />

  <go-hint
    *ngFor="let hint of hints"
    [message]="hint"
    [theme]="theme"
  ></go-hint>
  <div *ngIf="!hideFieldError">
    <go-form-errors [control]="control" [theme]="theme"></go-form-errors>
  </div>
</div>
